import { Box } from '@mui/material';
import Footer from 'components/Footer';
import React from 'react';
import { useLocation } from 'react-router-dom';
import CaseHeader from './CaseHeader';
import CaseHeroSection from './CaseHeroSection';
import CaseClientsSection from './CaseClientsSection';
import CaseProductDemo from './CaseProductDemo';
import CaseSolutions from './CaseSolutions';
import CaseDomainSection from './CaseDomainSection';
import CaseSuccessStory from './CaseSuccessStory';
import CasePricing from './CasePricing';
import TrustedInstitutions from './TrustedInstitutions';
import CaseFaq from './CaseFaq';
import CaseTestimonials from './CaseTestimonials';

/**
 * Scrolls to the section named by the URL hash, e.g. /#pricing.
 *
 * The browser resolves the fragment while parsing index.html, long before React
 * has mounted the section, so its native scroll finds nothing and gives up. We
 * retry across animation frames until the target exists, then re-align once the
 * page has finished loading in case late images shifted it.
 */
const useHashScroll = () => {
  const { hash } = useLocation();

  React.useEffect(() => {
    if (!hash) return undefined;

    const id = decodeURIComponent(hash.slice(1));
    let frame;
    let attempts = 0;

    const scrollToTarget = () => {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ block: 'start' });
        return true;
      }
      return false;
    };

    // ~1s of frames: the sections render synchronously, so this normally hits
    // on the first frame. The retry only covers a slow first paint.
    const attempt = () => {
      if (scrollToTarget() || attempts >= 60) return;
      attempts += 1;
      frame = requestAnimationFrame(attempt);
    };
    frame = requestAnimationFrame(attempt);

    const realign = () => scrollToTarget();
    window.addEventListener('load', realign);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('load', realign);
    };
  }, [hash]);
};

const CaseMaster = () => {
  useHashScroll();

  return (
    <Box>
      <CaseHeader />
      <Box sx={{ background: '#122A3A' }}>
        <CaseHeroSection />
        <CaseTestimonials />
        <CaseClientsSection />
      </Box>
      <CaseProductDemo />
      <CaseSolutions />
      <CaseSuccessStory />
      <CaseDomainSection />
      <CasePricing />
      <TrustedInstitutions />
      <CaseFaq />
      <Footer />
    </Box>
  );
};

export default CaseMaster;
